import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Theme } from 'OpsCenter/shared/components/button/button.component';

@Component({
  selector: 'app-approval-popup',
  template: require('./approval-popup.component.html'),
  styles: [require('./approval-popup.component.scss')],
})

export class ApprovalPopupComponent {
  @Input() title = 'Are you sure?';
  @Input() message = '';
  @Input() confirmButton = 'OK';
  @Input() confirmButtonTheme: Theme = 'primary';
  @Input() isLoading: boolean;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  public onConfirm() {
    this.confirmed.emit();
  }

  public onCancel() {
    this.cancelled.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/approval-popup/approval-popup.component.ts